export default "__VITE_ASSET__BnFcEagK__"